import { all } from "redux-saga/effects"
import { watchAnalyticEvents } from "./processAnalyticEvents"
import watchProcessApplyEditorChanges from "./processApplyEditorChanges"
import { watchApplyImageAITransformation } from "./processApplyImageAITransformation"
import {
  watchLogin,
  watchLoginResume,
  watchLoginSilently,
  watchLoginSuccess,
  watchLogout,
} from "./processAuth"
import { watchBootstrapPage } from "./processBootstrapPage"
import { watchBootstrapProductFeed } from "./processBootstrapProductFeed"
import watchProcessCouponCode from "./processCouponCode"
import watchProcessDownloadProductTemplates from "./processDownloadProductTemplates"
import { watchDuplicateLineItem } from "./processDuplicateLineItem"
import {
  watchQueueImageForProcessing,
  watchQueueImageForUploading,
} from "./processImagesInQueue"
import {
  watchAddLineItemToCart,
  watchCreateLineItem,
  watchCreateLineItemForProductId,
  watchCreateLineItemForProductIdAndTemplateId,
  watchCreateLineItemForProductIdAndTemplateIdWithPlaceholderImage,
  watchCreateLineItemForProductIdWithImageUrl,
  watchCreateLineItemForProductIdWithPlaceholderImage,
  watchCreateLineItemFromButton,
  watchCreateLineItemFromTemplate,
  watchFillLineItemImageRegionsWithImageUrls,
  watchInsertPageSpreadToLineItemAfter,
  watchInsertPageSpreadToLineItemBefore,
  watchRemoveIncompletePageSpreadsFromLineItem,
  watchRemoveLineItem,
  watchRemovePageSpreadFromLineItem,
  watchReplaceImageRegionImageWithImageUrl,
  watchSwapImageRegionFromPageAToPageB,
  watchUploadImagesAndCreateLineItemsForProductId,
  watchUploadImagesAndCreateLineItemsForProductIdAndTemplateId,
} from "./processLineItems"
import { watchProcessCreateOrder, watchProcessPlaceOrder } from "./processOrder"
import watchOrderFromStore from "./processOrderFromStore"
import { watchPlaceReOrder } from "./processPlaceReOrder"
import {
  watchRestoreCartDataFromLocalStorage,
  watchRestoreCheckoutDataFromLocalStorage,
} from "./processRestoreDataFromLocalStorage"
import watchProcessStoreInit from "./processStoreInit"
import watchProcessStoreSearch from "./processStoreSearch"
import watchProcessUpdateFulfillment from "./processUpdateFulfillment"
import watchUpdateImageRegionImage from "./processUpdateImageRegionImage"
import watchUpdateLineItemOrientation from "./processUpdateLineItemOrientation"
import watchUpdateLineItemProduct from "./processUpdateLineItemProduct"
import watchUpdateLineItemProductTemplate from "./processUpdateLineItemProductTemplate"
import watchUpdateLineItemProductTemplateVariant from "./processUpdateLineItemProductTemplateVariant"
import watchUpdateMissingImagesForLineItem from "./processUpdateMissingImagesForLineItem"
import watchProcessUpdateOrderSummary from "./processUpdateOrderSummary"
import watchProcessUpdateStore from "./processUpdateStore"
import {
  watchCreateUpload,
  watchCreateUploadFromButton,
  watchCreateUploadFromBuyNowButton,
  watchUploadUriImages,
} from "./processUploads"
import {
  watchProcessVNZImages,
  watchProcessVNZImageThumbnail,
  watchProcessVNZLogout,
  watchRefreshVNZAuthenticationToken,
  watchRestoreVNZAuthenticationStateFromLocalStorage,
  watchSaveVNZAuthentication,
  watchStartVNZAccessTokenRefresher,
} from "./processVNZ"

function* rootSaga() {
  // register all sagas here
  yield all([
    watchQueueImageForProcessing(),
    watchQueueImageForUploading(),
    watchCreateUpload(),
    watchCreateUploadFromButton(),
    watchCreateUploadFromBuyNowButton(),
    watchCreateLineItem(),
    watchRemoveLineItem(),
    watchCreateLineItemFromTemplate(),
    watchDuplicateLineItem(),
    watchUpdateLineItemProduct(),
    watchUpdateLineItemProductTemplate(),
    watchUpdateLineItemProductTemplateVariant(),
    watchUpdateLineItemOrientation(),
    watchUpdateMissingImagesForLineItem(),
    watchInsertPageSpreadToLineItemAfter(),
    watchInsertPageSpreadToLineItemBefore(),
    watchRemovePageSpreadFromLineItem(),
    watchRemoveIncompletePageSpreadsFromLineItem(),
    watchCreateLineItemFromButton(),
    watchSwapImageRegionFromPageAToPageB(),
    watchUpdateImageRegionImage(),
    watchProcessStoreInit(),
    watchProcessStoreSearch(),
    watchProcessPlaceOrder(),
    watchProcessCreateOrder(),
    watchProcessCouponCode(),
    watchProcessUpdateOrderSummary(),
    watchProcessDownloadProductTemplates(),
    watchProcessUpdateFulfillment(),
    watchProcessUpdateStore(),
    watchProcessApplyEditorChanges(),
    watchAddLineItemToCart(),
    watchLogin(),
    watchLoginSilently(),
    watchLoginResume(),
    watchRestoreCheckoutDataFromLocalStorage(),
    watchRestoreCartDataFromLocalStorage(),
    watchLoginSuccess(),
    watchLogout(),
    watchOrderFromStore(),
    watchBootstrapPage(),
    watchBootstrapProductFeed(),
    watchPlaceReOrder(),
    watchUploadUriImages(),
    watchAnalyticEvents(),
    watchApplyImageAITransformation(),
    watchUploadImagesAndCreateLineItemsForProductId(),
    watchCreateLineItemForProductIdWithPlaceholderImage(),
    watchUploadImagesAndCreateLineItemsForProductIdAndTemplateId(),
    watchCreateLineItemForProductIdAndTemplateIdWithPlaceholderImage(),
    watchCreateLineItemForProductId(),
    watchCreateLineItemForProductIdAndTemplateId(),
    watchCreateLineItemForProductIdWithImageUrl(),
    watchReplaceImageRegionImageWithImageUrl(),
    watchFillLineItemImageRegionsWithImageUrls(),
    watchSaveVNZAuthentication(),
    watchRestoreVNZAuthenticationStateFromLocalStorage(),
    watchRefreshVNZAuthenticationToken(),
    watchStartVNZAccessTokenRefresher(),
    watchProcessVNZImages(),
    watchProcessVNZLogout(),
    watchProcessVNZImageThumbnail(),
  ])
}

export default rootSaga
